import React from 'react'
import { Flex } from 'ui/acro'

const PageLayout = ({ children }) => (
  <Flex
    justifyContent='center'
    alignItems='center'
    flexDirection='column'
    mx={['auto']}
  >
    <Flex
      width='100%'
      maxWidth='1320px'
      flexDirection='column'
      padding={['0 35px 20px 35px', '0 40px 40px 40px']}
    >
      {children}
    </Flex>
  </Flex>
)

export default PageLayout
